import { render, staticRenderFns } from "./PendingBusiness.vue?vue&type=template&id=8403dfec&scoped=true&"
import script from "./PendingBusiness.vue?vue&type=script&lang=ts&"
export * from "./PendingBusiness.vue?vue&type=script&lang=ts&"
import style0 from "./PendingBusiness.vue?vue&type=style&index=0&id=8403dfec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8403dfec",
  null
  
)

export default component.exports